






























































































































import { computed, defineComponent, ref, PropType } from '@vue/composition-api';
import authMixin from '@/mixins/auth';

import {
  useDeleteBankPaymentInstructionProperty,
  useFetchBankPaymentInstructionProperties
} from '@/composable/bank';
import {
  IBankPaymentInstructionData,
  IBankPaymentInstructionProperty
} from '@/models';

import NoDataAvailablePlaceholder from '@/components/common/NoDataAvailablePlaceholder.vue';
import PaymentInstructionPropertyListItem from './PaymentInstructionPropertyListItem.vue';
import PaymentInstructionPropertyFormDialog from './PaymentInstructionPropertyDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default defineComponent({
  name: 'PaymentInstructionPropertyList',
  components: {
    ConfirmationDialog,
    NoDataAvailablePlaceholder,
    PaymentInstructionPropertyListItem,
    PaymentInstructionPropertyFormDialog,
    ErrorAlert
  },
  mixins: [authMixin],
  props: {
    instruction: {
      type: Object as PropType<IBankPaymentInstructionData>,
      default: null
    }
  },
  setup(props) {
    const dialog = ref(false);
    const selectedPaymentInstructionProperty = ref<IBankPaymentInstructionProperty | null>(
      null
    );

    function openPaymentInstructionPropertyFormDialog(
      paymentInstruction?: IBankPaymentInstructionProperty
    ) {
      selectedPaymentInstructionProperty.value = paymentInstruction ?? null;
      dialog.value = true;
    }

    const deleteDialog = ref(false);
    function openPaymentInstructionPropertyDeleteDialog(
      paymentInstruction: IBankPaymentInstructionProperty
    ) {
      selectedPaymentInstructionProperty.value = paymentInstruction;
      deleteDialog.value = true;
    }

    const currentInstructionId = computed(() => props.instruction.id!);

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deletePaymentInstructionProperty
    } = useDeleteBankPaymentInstructionProperty(currentInstructionId);

    function removePaymentInstructionProperty(
      paymentInstruction: IBankPaymentInstructionProperty
    ) {
      deletePaymentInstructionProperty(paymentInstruction.id!, {
        onSuccess: () => {
          closeDeleteDialog();
        }
      });
    }

    function closeDeleteDialog() {
      deleteDialog.value = false;
      selectedPaymentInstructionProperty.value = null;
    }

    const {
      isLoading: loading,
      paymentInstructionProperties,
      error
    } = useFetchBankPaymentInstructionProperties(currentInstructionId);

    function clearErrors() {
      deleteError.value = null;
      error.value = null;
    }

    return {
      currentInstructionId,
      loading,
      dialog,
      deleteDialog,
      selectedPaymentInstructionProperty,
      paymentInstructionProperties,
      error,
      deleteError,
      deleteInProgress,
      openPaymentInstructionPropertyFormDialog,
      openPaymentInstructionPropertyDeleteDialog,
      closeDeleteDialog,
      removePaymentInstructionProperty,
      clearErrors
    };
  }
});
